import type { Location, NavigateFunction } from 'react-router-dom';

/**
 * Push `?login=1` onto the current URL so the <LoginModal> listener opens.
 * Preserves other query params and hash; `replace` keeps the intermediate
 * auth state off the history stack (used by RequireAuth).
 */
export function openLoginModal(
  location: Location,
  navigate: NavigateFunction,
  options: { replace?: boolean } = {},
): void {
  const params = new URLSearchParams(location.search);
  if (params.get('login') === '1') return;
  params.set('login', '1');
  navigate(location.pathname + `?${params.toString()}` + location.hash, {
    replace: options.replace ?? false,
  });
}
